import { Navigate, useNavigate } from 'react-router-dom';

import { ErrorIndicator } from '@components/ErrorIndicator';
import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { IncomeProtectorContent } from '@features/IncomeProtector';
import { useBundleBasket } from '@hooks/useBundleBasket';
import { usePageStateHandler } from '@hooks/usePageStateHandler';
import { withProfiler } from '@services/sentry/withProfiler';
import { getInsuranceNavigationPaths } from '@utils/insurance';

const IncomeProtectorUnwrapped = () => {
  const navigate = useNavigate();
  const { basket, error, loading } = useBundleBasket({});
  const { isLoading, hasError } = usePageStateHandler({
    loading,
    hasData: !!basket,
    error,
  });

  if (isLoading || !basket) {
    return null;
  }

  const basketId = basket?.id;
  const { quote: insuranceQuote } = basket.insurance.incomeProtector;

  if (!insuranceQuote) {
    return <Navigate to={paths.insurance} />;
  }

  const { backPath, selectPath, deselectPath } = getInsuranceNavigationPaths({
    boilerAvailable: !!basket.insurance.boilerInsurance.available,
    incomeAvailable: !!basket.insurance.incomeProtector.available,
  });
  const backButtonLabel =
    backPath === paths.insurance ? 'Back to insurance' : 'Back to bundle';

  if (hasError) {
    return (
      <Layout
        title="Income Protector"
        onBack={() => navigate(backPath)}
        backButtonLabel={backButtonLabel}
      >
        <ErrorIndicator />
      </Layout>
    );
  }

  return (
    <Layout onBack={() => navigate(backPath)} backButtonLabel={backButtonLabel}>
      <IncomeProtectorContent
        basketId={basketId}
        insuranceQuote={insuranceQuote}
        onSelectCompleted={() => navigate(selectPath)}
        onDeselectCompleted={() => navigate(deselectPath)}
      />
    </Layout>
  );
};

const IncomeProtector = withProfiler(IncomeProtectorUnwrapped);
export { IncomeProtector };
